<template>
  <div
    class="button-group"
    v-if="l_visible"
    :class="{ readonly: readonly || getDisabled || isLoading }"
  >
    <div class="button-group-label" v-if="getLabel && labelVisible">
      {{ getLabel }} <span v-if="showRequired" class="text-required"></span>

      <v-tooltip v-if="!!getTooltip && labelTooltip" slot="append" bottom max-width="350">
        <template #activator="{ on }">
          <v-icon slot="activator" class="btn-help text-body-2 ml-2" v-on="on"
            >mdi-help-circle</v-icon
          >
        </template>
        <span> {{ getTooltip }} </span>
      </v-tooltip>
    </div>
    <v-progress-linear indeterminate v-if="isLoading"></v-progress-linear>
    <v-btn-toggle
      v-show="!isLoading"
      :value="l_value"
      v-bind:class="{
        'row button-group-select': select,
        'button-group-switch': switchBtn,
        'button-group-chip': chip,
      }"
      class="button-group"
      :mandatory="mandatory"
      group
      :multiple="multiple && (select || chip)"
      @change="onChange"
      :max="max"
    >
      <template v-if="select">
        <v-col cols="12" xl="3" lg="3" md="6" sm="12" v-for="(item, index) in l_data" :key="index">
          <v-btn :value="item.valueMember" :disabled="getDisabled" outlined class="pa-0">
            {{ item.displayMember }}
          </v-btn>
        </v-col>
      </template>
      <template v-if="switchBtn || chip">
        <template v-for="(item, index) in l_data">
          <template v-if="item.popis != '' && item.popis != null">
            <v-tooltip top :key="index" :open-delay="500" max-width="350">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    :key="index"
                    :value="item.valueMember"
                    :small="small"
                    :disabled="getDisabled || isItemDisabled(item)"
                    v-bind:class="{
                      'pa-0': switchBtn,
                    }"
                  >
                    {{ item.displayMember }}
                    <v-tooltip
                      v-if="!labelTooltip && !isMobile && !!getTooltipForItem(index)"
                      slot="append"
                      bottom
                      max-width="350"
                    >
                      <template #activator="{ on }">
                        <v-icon
                          class="btn-help text-body-2"
                          style="margin-left: auto !important"
                          v-on="on"
                          >mdi-help-circle</v-icon
                        >
                      </template>
                      <span> {{ getTooltipForItem(index) }} </span>
                    </v-tooltip>
                    <v-icon v-if="chip" right dark size="14"> mdi-check </v-icon>
                  </v-btn>
                </div>
              </template>
              <span>{{ item.popis }}</span>
            </v-tooltip>
          </template>
          <template v-else>
            <v-btn
              :key="index"
              :value="item.valueMember"
              :small="small"
              :disabled="getDisabled || isItemDisabled(item)"
              v-bind:class="{
                'pa-0': switchBtn,
              }"
            >
              <div style="width: 150px" v-if="!labelTooltip && !isMobile && !!getTooltipForItem(index)">
                {{ item.displayMember }}
                <v-tooltip bottom max-width="350">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="btn-help text-body-2"
                      style="float: right; margin-left: -8px !important; margin-right: 8px"
                      right
                      v-on="on"
                      v-bind="attrs"
                      >mdi-help-circle</v-icon
                    >
                  </template>
                  <span> {{ getTooltipForItem(index) }}</span>
                </v-tooltip>
                <v-icon v-if="chip" right dark size="14"> mdi-check </v-icon>
              </div>
              <template v-else>
                {{ item.displayMember }} <span class="gs200" v-if="!labelTooltip && isMobile && !!getTooltipForItem(index)">*</span>
                <v-icon v-if="chip" right dark size="14"> mdi-check </v-icon>
              </template>
            </v-btn>
          </template>
        </template>
      </template>
    </v-btn-toggle>
    <div class="button-group-info" v-if="!labelTooltip && isMobile && getTooltipForItems != null" v-html="getTooltipForItems" >
    </div>
    <div class="button-group-info" v-if="info">
      {{ info }}
    </div>
  </div>
</template>
<script>
import { dynamicControlMixin } from '../../mixins/dynamicControlMixin';
import { mapGetters } from 'vuex';

export default {
  watch: {
    value(val) {
      if (val !== this.l_value) {
        if(!this.ignoreDirty)
          this.setDirty(true);
        this.update(val);
      }
    },
  },
  mixins: [dynamicControlMixin],
  props: {
    multiple: Boolean,
    switchBtn: Boolean,
    select: Boolean,
    chip: Boolean,
    items: Array,
    value: [String, Number, Array],
    small: Boolean,
    label: String,
    labelTooltip: Boolean,
    info: String,
    mandatory: {
      type: Boolean,
      default: true,
    },
    max: Number,
    disabled: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    showRequired: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      l_value: null,
      viewObjectText: null,
      viewObjectInfoText: null,
      l_data: [],
      labelVisible: true,
    };
  },
  computed: {
    ...mapGetters(['isMobile']),
    getDisabled() {
      return this.disabled || this.isDisabled;
    },
    getTooltipForItems() {
      if(this.getTooltip){
        let tooltipArray = this.getTooltip?.split('#');
        let text = '<span class="gs200">';
        let nextBr = false;
        for(let i = 0; i < tooltipArray.length ; i++){
          if(tooltipArray[i].length > 0){
            if(nextBr)
              text += '<br/>'
            nextBr = true;
            text += '<span>' + tooltipArray[i] + '</span>'
          }
        }
        text += '</span>'
        return tooltipArray != null ? text : null;
      }else{
        return null;
      }
    },
  },
  methods: {
    onChange(val) {
      if(!this.ignoreDirty)
        this.setDirty(true);
      this.update(val);
    },
    update(val) {
      this.l_value = val;
      this.$emit('input', val);
      if (this.dirty || this.ignoreDirty) {
        this.saveValue(val,this.ignoreDirty);
      }
    },
    readData(config, data) {
      this.viewObjectText = config.viewObjectText;
      this.viewObjectInfoText = config.viewObjectInfoText;
      if (this.l_data.length === 0) {
        this.l_data = data;

        if (!data) {
          let i = 0;
          this.l_data = this.viewObjectText.split('#').map(o => {
            //toto vymyslel Skyfko ze pri jednoduchych prepinacoch dat tie moznosti do nazvu oddelene #
            let curr = {
              valueMember: i,
              displayMember: o,
            };
            i++;
            if (!this.staticLabel) this.labelVisible = false;
            return curr;
          });
        }
      }

      if (config.controlValue !== null && config.controlValue !== undefined) {
        if (this.multiple) {
          this.l_value = config.controlValue.split(',');
        } else {
          this.l_value = config.controlValue;
        }
        this.$emit('input', this.l_value);
      }
    },
    getValue() {
      return this.l_value;
    },
    isItemDisabled(item) {
      if (item?.is_enabled != null) {
        return !item?.is_enabled ? true : false;
      } else {
        return false;
      }
    },
    getTooltipForItem(index) {
      let tooltipArray = this.getTooltip?.split('#');
      return tooltipArray != null ? tooltipArray[index] : null;
    },
    
  },
  created() {
    if (this.multiple) {
      this.l_value = [];
    }
    if (!this.dynamic) {
      if (this.items) this.l_data = this.items;
    }

    if (this.value) this.l_value = this.value;
  },
  mounted() {
    if (!this.data_id && this.data.length > 0) {
      this.l_data = this.data;
    }
  },
};
</script>
